import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.phonePackage.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "phonePackageSearch",
  fields: [
    name
  ]
}
